import React, {} from 'react';
import { ThemeContext } from './useTheme.js';
import { useSystemTheme } from './useSystemTheme.js';
/**
 * Applies the light or dark theme from the system setting, following changes live.
 * Everything inside resolves its design tokens from the `data-theme` wrapper; without a readable setting it is light.
 * Parts that must be told the theme instead read it with `useTheme()`.
 */
export function ThemeProvider({ children }) {
    const theme = useSystemTheme();
    return (React.createElement(ThemeContext.Provider, { value: theme },
        React.createElement("div", { "data-theme": theme }, children)));
}
//# sourceMappingURL=ThemeProvider.js.map